import { Link, makeStyles, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import { SubmitButton, TextField } from "../../components/formik";
import { login } from "../../ducks/actions";
import useNotifications from "../../hooks/useNotifications";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    alignSelf: "flex-start"
  },
  submitButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }
}));

const LoginForm = () => {
  const intl = useIntl();
  const classes = useStyles();

  const validationSchema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required()
  });
  const dispatch = useDispatch();
  const { ok, ko } = useNotifications();

  const onLogin = async value => {
    const response = await dispatch(login(value));
    if (response.error) {
      ko(
        intl.formatMessage({
          id: "Auth.LoginForm.LoginError",
          defaultMessage: "Login error"
        })
      );
    } else {
      ok(
        intl.formatMessage({
          id: "Auth.LoginForm.LoginSuccess",
          defaultMessage: "Login success"
        })
      );
    }
  };

  return (
    <>
      <Formik
        validationSchema={validationSchema}
        onSubmit={onLogin}
        initialValues={{ email: "", password: "" }}
      >
        <Form>
          <Typography variant="h4" className={classes.alignLeft} gutterBottom>
            {intl.formatMessage({ id: "Auth.LoginForm.Login", defaultMessage: "Login" })}
          </Typography>
          <Typography variant="body1" className={classes.alignLeft}>
            {intl.formatMessage({
              id: "Auth.LoginForm.Helper",
              defaultMessage: "Insert email and password to join the conference."
            })}
          </Typography>
          <TextField
            name="email"
            variant="outlined"
            label={intl.formatMessage({
              id: "Auth.LoginForm.EmailAddress",
              defaultMessage: "E-mail address"
            })}
            fullWidth
          />
          <TextField
            name="password"
            variant="outlined"
            label={intl.formatMessage({
              id: "Auth.LoginForm.Password",
              defaultMessage: "Password"
            })}
            type="password"
            fullWidth
          />
          <SubmitButton
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
          >
            {intl.formatMessage({ id: "Auth.LoginForm.Login", defaultMessage: "Login" })}
          </SubmitButton>
          {/* Work around to let Formik handle submit on press enter */}
          <input type="submit" name="btnOnKeyPress" value="" style={{ display: "none" }} />
        </Form>
      </Formik>
      <Typography>
        <Link to="/forgot-password" component={RouterLink}>
          {intl.formatMessage({
            id: "Auth.LoginForm.ForgotPassword",
            defaultMessage: "Forgot Password"
          })}
        </Link>
        &nbsp;
        {intl.formatMessage({
          id: "Auth.LoginForm.Or",
          defaultMessage: "or"
        })}
        &nbsp;
        <Link to="/access-code" component={RouterLink}>
          {intl.formatMessage({
            id: "Auth.LoginForm.RegisterNow",
            defaultMessage: "Register now"
          })}
        </Link>
      </Typography>
    </>
  );
};

export default LoginForm;
